let formatter = null;

export default function priceFormatter(price, removeUSD = false) {
  if (formatter === null) {
    formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }

  const formatted = formatter.format(price);

  if (removeUSD) {
    return formatted;
  }

  return `${formatted} USD`;
}
